export default __webpack_public_path__ + "static/media/icn-delivery-truck-red.3580ccd1.svg";